export class SaldoAdiantamento {
  divisao : string;
  empresa : string;
  exercicio : string;
  item : string;
  montante : string;
  numAdiantamento : string;
  numSolAdiantamento : string;
  referencia : string;
  vencimento : string; 
  descDivisao: string;

  status: string;
  mensagem: string;
  checked: boolean;
}